import PropTypes from 'prop-types';
import React from 'react';
import { SCSelect } from 'rollup-allspark';

/**
 * Business scope for the drawer. kAI needs `context.business_id` on every /ask
 * (contract §2) and shadowchef has no global business switcher, so the drawer
 * carries its own — defaulted from the Native Analytics selection or the first
 * kAI-enabled business, and hidden entirely when there's only one choice.
 */
const BusinessContext = ({ businesses, businessId, onChange, disabled }) => {
  if (!businesses || businesses.length <= 1) return null;

  const selected = businesses.find(b => b.id === businessId) || null;

  return (
    <div className="border-b border-grey-light px-4 py-2">
      <SCSelect
        label="title"
        trackBy="id"
        options={businesses}
        value={selected}
        customLabel={b => `${b.id}. ${b.title}`}
        searchAbleAttribute={['title', 'id']}
        onSelect={b => onChange(b?.id)}
        searchable
        allowEmpty={false}
        placeholder="Select a business"
        disabled={disabled}
      />
    </div>
  );
};

BusinessContext.propTypes = {
  businesses: PropTypes.array,
  businessId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default BusinessContext;
